import Store from '../Store';

const B2BOrderStore = new Store('b2b/orders');

export default B2BOrderStore;